import BlockTypes from '../../../types/BlockTypes';
import withoutSelectionSnapshots from '../../utils/withoutSelectionSnapshots';
export default function emptyTableCellsAtSelection(editor) {
  if (editor.value.selection.isCollapsed) {
    return editor;
  }

  var cells = editor.value.blocks.filter(function (block) {
    return block.type === BlockTypes.TABLE_CELL;
  });
  var _editor$value = editor.value,
      startBlock = _editor$value.startBlock,
      endBlock = _editor$value.endBlock;
  var selection = editor.value.selection;
  editor.snapshotSelection();
  withoutSelectionSnapshots(editor, function () {
    editor.withoutNormalizing(function () {
      cells.forEach(function (cell) {
        if (cell === startBlock && cell === endBlock) {
          editor.deleteAtRange(selection);
        } else if (cell === startBlock) {
          var range = selection.moveEndToEndOfNode(cell.getLastText()).normalize(editor.value.document);

          if (!range.isCollapsed) {
            editor.deleteAtRange(range);
          }
        } else if (cell === endBlock) {
          var _range = selection.moveStartToStartOfNode(cell.getFirstText()).normalize(editor.value.document);

          if (!_range.isCollapsed) {
            editor.deleteAtRange(_range);
          }
        } else {
          editor.emptyTableCell(cell);
        }
      });
    });
  });

  if (editor.value.startBlock.type !== BlockTypes.TABLE_CELL) {
    var firstCellText = editor.value.blocks.find(function (block) {
      return block.type === BlockTypes.TABLE_CELL;
    }).getFirstText();
    var previousText = editor.value.document.getPreviousText(firstCellText.key);
    return previousText ? editor.moveEndToEndOfNode(previousText) : editor;
  } else if (editor.value.endBlock.type !== BlockTypes.TABLE_CELL) {
    var lastCell = editor.value.blocks.reverse().find(function (block) {
      return block.type === BlockTypes.TABLE_CELL;
    });
    var nextText = editor.value.document.getNextText(lastCell.key);
    return nextText ? editor.moveStartTo(nextText.key) : editor;
  }

  return editor.moveTo(selection.start.key, selection.start.offset);
}